var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Multiply } from "@safetyculture/icons-react";
import { IconButton } from "../button";
import { Stack } from "../stack";
import styled, { css } from "../styled";
import { pxToRem } from "../utils";
const ActionSlotContainer = styled.div `
  display: flex;
  flex-shrink: 0;
  gap: ${(p) => p.theme._ui.space.s1};
  ${(p) => p.direction === "row" &&
    css `
      margin-left: auto;
    `};
`;
const Container = styled.div `
  width: 100%;
  display: flex;
  white-space: break-spaces;
  justify-content: flex-start;
  align-items: center;
  padding: ${pxToRem(5)} 0;
`;
const StyledIconButton = styled(IconButton) `
  margin-left: ${(p) => p.theme._ui.space.s4};
  flex-shrink: 0;
`;
const IconContainer = styled.div `
  display: flex;
  flex-shrink: 0;
  margin-right: ${(p) => p.theme._ui.space.s4};
  align-self: flex-start;
`;
const BannerContainer = styled.div `
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  padding: ${pxToRem(7)} ${(p) => p.theme._ui.space.s4};
`;
const Banner = forwardRef((_a, ref) => {
    var { closeProps, direction = "row", icon, children, actionsSlot, dataAnchor } = _a, rest = __rest(_a, ["closeProps", "direction", "icon", "children", "actionsSlot", "dataAnchor"]);
    const closeButton = (React.createElement(StyledIconButton, { size: "small", variant: "inherit", icon: React.createElement(Multiply, null), dataAnchor: "close-icon-button", ariaLabel: "close banner", onClick: closeProps === null || closeProps === void 0 ? void 0 : closeProps.onClick }));
    return (React.createElement(BannerContainer, Object.assign({}, rest, { ref: ref, "data-anchor": dataAnchor }),
        React.createElement(Container, null,
            !!icon && React.createElement(IconContainer, null, icon),
            React.createElement(Stack, { spacing: "s2", direction: direction },
                children,
                actionsSlot && (React.createElement(ActionSlotContainer, { direction: direction }, actionsSlot)))),
        !!closeProps && closeButton));
});
export default Banner;
